export default "__VITE_ASSET__BQvJFnPh__"